// extracted by mini-css-extract-plugin
export default {"modal":"SelectServerRule_modal__KnFSV","tips":"SelectServerRule_tips__FEwqH"};